import { defineStyleConfig } from "@chakra-ui/react";

export const Switch = defineStyleConfig({
  baseStyle: {
    track: {
      _checked: {
        bg: "green.500",
      },
    },
  },
  defaultProps: {
    size: "md",
    colorScheme: "brand",
  },
});